<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-start
      wrap
    >
      <v-flex
        md5
        xs12
        mb-0
        mt-0
        pb-0
      >
        <h2>
          {{
            toggle === "request"
              ? $t("modules.applications")
              : $t("modules.licenses")
          }}
        </h2>
      </v-flex>
      <v-flex
        md3
        xs12
        mb-0
        mt-0
        pb-0
        :class="!$vuetify.breakpoint.xs ? 'pt-5 text-right' : 'pt-0'"
      >
        <v-text-field
          v-model.trim="search"
          name="search"
          max-length="100"
          style="width: 220px"
          prepend-inner-icon="mdi-text-box-search-outline"
        >
          <template v-slot:append>
            <v-icon
              v-if="search"
              style="cursor: pointer"
              @click="search = null"
            >
              mdi-close
            </v-icon>
          </template>
        </v-text-field>
      </v-flex>
      <v-flex
        md4
        xs12
        mb-0
        mt-0
        pb-0
        :class="
          !$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm
            ? 'pt-9 text-right'
            : 'pb-5'
        "
      >
        <v-btn-toggle
          v-model="toggle"
          divided
          outlined
          @change="search = null"
        >
          <v-btn
            small
            value="request"
          >
            {{ $t("modules.applications") }}
          </v-btn>
          <v-btn
            small
            value="licenses"
          >
            {{ $t("modules.licenses") }}
          </v-btn>
        </v-btn-toggle>
      </v-flex>
      <v-flex xs12>
        <RequestsView
          v-if="toggle === 'request'"
          :whitelabel-uuid="getWhiteLabel.uuid"
          :search="search"
        />
        <LicenseView
          v-else
          :whitelabel-uuid="getWhiteLabel.uuid"
          :search="search"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import RequestsView from "@/views/Modules/Licenses/partial/RequestsView.vue";
import LicenseView from "@/views/Modules/Licenses/partial/LicenseView.vue";
import { mapGetters } from "vuex";

export default {
  name: "ModuleLicenses",
  components: {
    RequestsView,
    LicenseView,
  },
  data() {
    return {
      tab: null,
      search: null,
      toggle: "request",
      whitelabel_uuid: null,
    };
  },
  computed: {
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
  },
  methods: {
    checkToggle() {
      console.log("checkToggle");
    },
  },
};
</script>
<style lang="scss" scoped></style>
